<template>
  <v-footer
    id="core-footer"
    absolute
    height="82"
  >
    <div class="footer-items">
      <v-img v-if='showLogo' src='/img/logo.png'/>
      <!--span
        v-for="link in links"
        :key="link.name"
      >
        <a
          :href="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</a>
      </span-->
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      {{ version }}
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="https://www.emnresearch.it/"
        target="_blank">EMN</a>, made with
      <v-icon
        color="tertiary"
        size="17">mdi-heart</v-icon>
      for a better world
    </span>
  </v-footer>
</template>

<script>
const { version } = require('../../../package.json')
export default {
  props: {
    showLogo: { type: Boolean, deafult: false }
  },
  data: () => ({
    version,
    links: [
      { name: 'Home', Link: '/dashboard' },
      { name: 'Creative Tim', Link: 'https://www.creative-tim.com' },
      { name: 'About Us', Link: 'https://creative-tim.com/presentation' },
      { name: 'Blog', Link: 'https://blog.creative-tim.com' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
